import React from 'react';
import '../styles/components/AllergiesSection.css';

const AllergiesSection = ({ formData, setFormData }) => {
  // よくあるアレルギー食材（ProfileEditと同じ）
  const commonAllergies = [
    '卵', '乳（牛乳）', '小麦', 'えび', 'かに', '落花生（ピーナッツ）', 'そば', '魚類'
  ];

  // よく避けられる食材カテゴリー（ProfileEditから主要なもの）
  const commonAvoidFoods = [
    '肉類全般', '魚類全般', '乳製品全般', '卵全般',
    '動物性食品全般（ヴィーガン）', '豚肉（ハラール）',
    'グルテン', '化学調味料全般', '人工甘味料'
  ];

  // プロフィールからのデフォルト値
  const profileAllergies = formData.allergies?.profileAllergies || [];
  const profileAllergiesOther = formData.allergies?.profileAllergiesOther || '';
  const profileAvoidFoods = formData.allergies?.profileAvoidFoods || [];
  const profileAvoidFoodsOther = formData.allergies?.profileAvoidFoodsOther || '';

  // 編集中の値（初期値はプロフィールから）
  const currentAllergies = formData.allergies?.currentAllergies || profileAllergies;
  const currentAllergiesOther = formData.allergies?.currentAllergiesOther || profileAllergiesOther;
  const currentAvoidFoods = formData.allergies?.currentAvoidFoods || profileAvoidFoods;
  const currentAvoidFoodsOther = formData.allergies?.currentAvoidFoodsOther || profileAvoidFoodsOther;
  const additionalNotes = formData.allergies?.additionalNotes || '';

  // チェックボックス切り替え
  const handleAllergyToggle = (allergy) => {
    const newAllergies = currentAllergies.includes(allergy)
      ? currentAllergies.filter(a => a !== allergy)
      : [...currentAllergies, allergy];

    setFormData(prev => ({
      ...prev,
      allergies: {
        ...prev.allergies,
        currentAllergies: newAllergies
      }
    }));
  };

  const handleAvoidFoodToggle = (food) => {
    const newAvoidFoods = currentAvoidFoods.includes(food)
      ? currentAvoidFoods.filter(f => f !== food)
      : [...currentAvoidFoods, food];

    setFormData(prev => ({
      ...prev,
      allergies: {
        ...prev.allergies,
        currentAvoidFoods: newAvoidFoods
      }
    }));
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      allergies: {
        ...prev.allergies,
        [field]: value
      }
    }));
  };

  const hasProfileData = profileAllergies.length > 0 || profileAllergiesOther ||
                         profileAvoidFoods.length > 0 || profileAvoidFoodsOther;

  return (
    <div className="allergies-section">
      <h3 className="allergies-section__title">🚫 NG食材・アレルギー</h3>
      <p className="allergies-section__description">
        {hasProfileData ? 'プロフィール情報が反映されています。このページで編集できます。' : 'アレルギーや避けたい食材を選択してください（任意）'}
      </p>

      {/* アレルギー食材 */}
      <div className="allergies-section__category">
        <h4 className="allergies-section__category-title">🚨 アレルギー食材</h4>

        <div className="allergies-section__checkbox-grid">
          {commonAllergies.map((allergy) => {
            const isChecked = currentAllergies.includes(allergy);
            return (
              <label
                key={allergy}
                className={`allergies-section__checkbox-card ${isChecked ? 'allergies-section__checkbox-card--selected' : ''}`}
              >
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={() => handleAllergyToggle(allergy)}
                  className="allergies-section__checkbox"
                />
                <span className="allergies-section__checkbox-label">
                  {isChecked && <span className="allergies-section__check-icon">✓</span>}
                  {allergy}
                </span>
              </label>
            );
          })}
        </div>

        <div className="allergies-section__input-field">
          <label className="allergies-section__label">その他のアレルギー食材</label>
          <input
            type="text"
            className="allergies-section__input"
            value={currentAllergiesOther}
            onChange={(e) => handleInputChange('currentAllergiesOther', e.target.value)}
            placeholder="例: バナナ、キウイ"
          />
        </div>
      </div>

      {/* 避けたい食材 */}
      <div className="allergies-section__category">
        <h4 className="allergies-section__category-title">❌ 避けたい食材</h4>
        <p className="allergies-section__category-hint">
          アレルギーではないが避けたい食材（嫌いな食べ物、宗教的制限など）
        </p>

        <div className="allergies-section__checkbox-grid">
          {commonAvoidFoods.map((food) => {
            const isChecked = currentAvoidFoods.includes(food);
            return (
              <label
                key={food}
                className={`allergies-section__checkbox-card ${isChecked ? 'allergies-section__checkbox-card--selected' : ''}`}
              >
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={() => handleAvoidFoodToggle(food)}
                  className="allergies-section__checkbox"
                />
                <span className="allergies-section__checkbox-label">
                  {isChecked && <span className="allergies-section__check-icon">✓</span>}
                  {food}
                </span>
              </label>
            );
          })}
        </div>

        <div className="allergies-section__input-field">
          <label className="allergies-section__label">その他の避けたい食材</label>
          <input
            type="text"
            className="allergies-section__input"
            value={currentAvoidFoodsOther}
            onChange={(e) => handleInputChange('currentAvoidFoodsOther', e.target.value)}
            placeholder="例: レバー、チーズ、パクチー"
          />
        </div>
      </div>

      {/* 今回の相談用の追加メモ */}
      <div className="allergies-section__notes">
        <label className="allergies-section__label">
          今回の相談用メモ（任意）
        </label>
        <textarea
          className="allergies-section__textarea"
          value={additionalNotes}
          onChange={(e) => handleInputChange('additionalNotes', e.target.value)}
          placeholder="例: 今日は卵を控えめにしたい、今回だけ避けたい食材など"
          rows="2"
        />
      </div>
    </div>
  );
};

export default AllergiesSection;
